var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pj-err c-text-c"},[_c('h1',[_c('b',[_vm._v("404")])]),_c('h2',{staticClass:"c-color-t"},[_c('b',[_vm._v("THIS PAGE NOT FOUND !")])]),_c('h5',{staticClass:"o-mt"},[_vm._v("抱歉，当前页面不存在")])])
}]

export { render, staticRenderFns }